import api from './api';
import { CtrPcsResultData } from './ctrPcs';

export interface PosFornecedorPcm {
    numeroPcm: string;
    fornecedorId: string;
}

export const getAllPedidoFornecedorFake = () => api.get<CtrPcsResultData[]>(`manutencaoPcmFornecedor/getAll`);
export const getAllPedidoFornecedorFakeCrf = () => api.get<any[]>(`manutencaoPcmFornecedor/getAllCrf`);
export const alterarForncedorDoPcm = (values: PosFornecedorPcm) => api.put<PosFornecedorPcm>(`manutencaoPcmFornecedor/alterarForncedorDoPcm`, values);
export const alterarForncedorDoPcmCrf = (values: PosFornecedorPcm) => api.put<PosFornecedorPcm>(`manutencaoPcmFornecedor/alterarForncedorDoPcmCrf`, values);